import React, { useState, useEffect, useRef } from 'react'
import { Svg, Circle, CircleBackground } from './styled';
import { ICircularProgressBarProps } from './types';

const CircularProgressBar: React.FC<ICircularProgressBarProps> = ({
  size = 0,
  strokeWidth = 0,
  circleColor,
  circleBackgroundColor,
  progress = 0,
  testId
}) => {
  const [offset, setOffset] = useState<number>(0);
  const circleRef = useRef<SVGCircleElement>(null);

  const center = size / 2;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    const progressOffset = ((100 - progress) / 100) * circumference;
    setOffset(progressOffset);
    if(circleRef.current) {
      circleRef.current.setAttribute('style', 'transition: "stroke-dashoffset 850ms ease-in-out"');
    }

  }, [circumference, progress, offset]);

  return (
    <>
      <Svg width={size} height={size} data-testid={testId}>
        <CircleBackground
          stroke={circleBackgroundColor}
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <Circle
          stroke={circleColor}
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          ref={circleRef}
        />
      </Svg>
    </>
  );
}

CircularProgressBar.defaultProps = {
  size: 22,
  strokeWidth: 2,
  circleBackgroundColor: 'rgba(0, 0, 0, .1)',
  circleColor: '#000',
  progress: 0
};

export default CircularProgressBar;